import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';

const componentName = "RestockbyCaps";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            {/* <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div>
            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    fullWidth={true}
                    defaultValue={props.loggedBranch.toString()}
                    label={LOOKUP.report.common.branch}
                    floatingLabelText={LOOKUP.report.common.branch}
                    hintText={LOOKUP.report.common.branch}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue="2"
                    label={"Type"}
                    floatingLabelText={"Type"}
                    hintText={"Type"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div>  {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-4 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.subcategory}
                    floatingLabelText={LOOKUP.report.common.subcategory}
                    hintText={LOOKUP.report.common.subcategory}
                    options={props.productCategories && props.productCategories.length > 0 ? (props.isCannabis == 0 ? props.productCategories.filter(x => !x.isCannabis) : (props.isCannabis == 1 ? props.productCategories.filter(x => x.isCannabis) : props.productCategories)) : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label="Download Report"
                    onTouchTap={props.downloadReport}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p><b>Note: </b><strong className="blue-text"><i>Products with zero as restock cap value won't show up in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
